/**
 * `new Date(null).toLocaleDateString()` is "1/1/1970". Dance Program Booking showed
 * that next to a ₹25,000 amount because /api/dance-program/my-requests returns
 * eventDate: null for some legacy requests (portal audit 2026-09-24). Render a
 * placeholder instead — the same "Date TBD" the server's own messages use
 * (danceProgramApprovalService.formatEventDateSimple). Valid dates format exactly
 * as before.
 */
export function formatOptionalLocaleDate(
  value: string | number | Date | null | undefined,
  placeholder = 'Date TBD',
): string {
  if (value === null || value === undefined || value === '') return placeholder;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return placeholder;
  return d.toLocaleDateString();
}
